/** Returns the cleaned list of points, or an error sentence — one rule for the form and tests. */
export function cleanBullets(raw: string[]): string[] {
  return raw.map((b) => b.replace(/^\s*[-•*]\s*/, '').trim()).filter((b) => b.length > 0)
}

export function isHttpLink(value: string): boolean {
  try {
    const u = new URL(value.trim())
    return u.protocol === 'https:' || u.protocol === 'http:'
  } catch {
    return false
  }
}
